// @flow

import React from "react";

import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Checkbox } from "@chakra-ui/react";
import { ListItem } from "./styles";
import { DragHandle } from "src/components/Unifize/DragHandle";
import Icon from "src/icons";
import { processColumnNames } from "src/constants/display";
import { iconSize } from "src/styles/constants/size";

type Props = {
  id: string | number,
  column: Object,
  handleCheckbox: Function,
  isReadOnly: boolean,
};

function SortableItem({
  id,
  column,
  handleCheckbox,
  isReadOnly = false,
}: Props) {
  const { listeners, setNodeRef, setActivatorNodeRef, transform, transition } =
    useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  const columnLabel = column.label
    ? column.label
    : processColumnNames[column.key];

  const handleClick = () => {
    if (isReadOnly) {
      return;
    }
    handleCheckbox(column.key);
  };

  return (
    <ListItem ref={setNodeRef} style={style}>
      <div>{columnLabel}</div>
      <div onClick={handleClick}>
        <Checkbox
          isDisabled={isReadOnly}
          isChecked={isReadOnly ? true : column.active}
        />
      </div>

      <DragHandle
        dragHandleRef={setActivatorNodeRef}
        dragHandleListeners={listeners}
        icon={
          <Icon
            type="draggable"
            size={iconSize.space_m}
            style={{
              visibility: column.key === "seqNo" ? "hidden" : "visible",
            }}
          />
        }
      />
    </ListItem>
  );
}

export default SortableItem;
